import type { PropType } from 'vue';
import type { DeepPartial } from '../../types';
import { merge } from 'es-toolkit/compat';
import { computed, defineComponent, h, provide } from 'vue';
import { injectionKey } from '../../composables/theme';
import { baseTheme } from '../../theme';

export interface TThemeProviderProps {
  theme?: DeepPartial<typeof baseTheme>;
}

export const TThemeProvider = defineComponent({
  name: 'TThemeProvider',
  inheritAttrs: false,
  props: {
    theme: {
      type: Object as PropType<TThemeProviderProps['theme']>,
      default: () => {},
    },
  },
  setup(props, { slots, attrs }) {
    const theme = computed(() => merge(baseTheme, props.theme));
    provide(injectionKey, theme);
    return () => h('div', { ...attrs }, slots.default?.());
  },
});
